export default __webpack_public_path__ + "static/media/Screenshot_13.b969cbd9.png";